import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ApiService } from "../shared/utilities/api.service";
import { Discussion, VoterListConfig } from "../../models";
import { DiscussionVoteListResult } from "../../interfaces";

@Injectable()
export class DiscussionVoteService {
  constructor(private apiService: ApiService) {}

  public upvote(discussion: Discussion): Observable<Discussion> {
    // POST /api/discussions/:community/:discussion/vote?type=upvote
    const communityName = discussion.community.name;
    const discussionSlug = discussion.slug;
    const postURL = `/discussions/${communityName}/${discussionSlug}/vote?type=upvote`;

    return this.apiService.post(postURL);
  }

  public downvote(discussion: Discussion): Observable<Discussion> {
    // POST /api/discussions/:community/:discussion/vote?type=downvote
    const communityName = discussion.community.name;
    const discussionSlug = discussion.slug;
    const postURL = `/discussions/${communityName}/${discussionSlug}/vote?type=downvote`;

    return this.apiService.post(postURL);
  }

  public fetchVoters(
    discussion: Discussion,
    config: VoterListConfig
  ): Observable<DiscussionVoteListResult> {
    let params = {};

    Object.keys(config).forEach((key) => {
      params[key] = config[key];
    });

    // GET api/discussions/:community/:discussion/votes
    const communityName = discussion.community.name;
    const discussionSlug = discussion.slug;
    const getURL = `/discussions/${communityName}/${discussionSlug}/votes`;

    var finalParams = new HttpParams({ fromObject: params });
    return this.apiService.get(getURL, finalParams).pipe(map((data) => data));
  }
}
